import React from "react";
import AppShell from "./v2/AppShell";
import type { BaseComponentProps } from "../../types";

interface MainLayoutProps extends BaseComponentProps {
  children: React.ReactNode;
}

/**
 * MainLayout — v2 shell wrapper.
 * Delegates to AppShell which implements the CSS-var two-layer navigation
 * (64px icon rail + 232px contextual sub-nav + 56px topbar).
 */
const MainLayout: React.FC<MainLayoutProps> = (props) => {
  return <AppShell {...props} />;
};

export default MainLayout;
